// extracted by mini-css-extract-plugin
export default {"container":"Centered_container__ws-f-","vertical":"Centered_vertical__4IQDh","horizontal":"Centered_horizontal__+SPPA"};